import { createReducer } from '@reduxjs/toolkit'
import { types } from 'actions/overview_actions'
import OverviewLocalStore from 'local_storages/overview'

export default createReducer({}, (builder) => {
  builder
    .addCase(types.INIT, (state, action) => {
      Object.assign(state, action.data)
    })
    .addCase(types.SELECT, (state, action) => {
      if (!state.projectGroups) state.projectGroups = []
      if (!state.mspWorkflows) state.mspWorkflows = []
      
      state.projectGroups.push(...(action.data.projectGroups || []))
      state.mspWorkflows.push(...(action.data.mspWorkflows || []))
      state.comments = action.data.comments
      state.statusChanges = action.data.statusChanges
    })
    .addCase(types.GET_PROJECTS, (state, action) => {
      state.projects = action.data.projects
    })
})
